import * as React from "react";
import { Box, Skeleton, Stack, SkeletonCircle } from "@chakra-ui/react";

const SkeletonOfferReleted: React.FC = () => (
  <Stack spacing={8} display={["none", "flex"]}>
    {[...Array(5)].map((_, idx) => (
      <Box key={idx}>
        <Stack direction="row" w="694px">
          <Skeleton h="225px" w="300px" />
          <Stack w="394px">
            <Stack direction="row" justify="space-between">
              <Skeleton h="15px" w="100px" />
              <Skeleton h="20px" w="50px" />
            </Stack>
            <Skeleton h="20px" w="210px" />
            <Skeleton h="20px" w="90px" />
          </Stack>
        </Stack>
        {idx === 0 && (
          <Stack
            h="150px"
            w="694px"
            my="40px"
            direction="row"
            backgroundColor="ud-white"
            align="center"
            pl="30px"
          >
            <SkeletonCircle boxSize="50px" />
            <Stack>
              <Skeleton h="15px" w="240px" />
              <Skeleton h="20px" w="380px" />
            </Stack>
          </Stack>
        )}
      </Box>
    ))}
  </Stack>
);

export default SkeletonOfferReleted;
